"use strict";
var React = require("react");
var ReactDOM = require('react-dom');
var LinkedStateMixin = require("react-addons-linked-state-mixin");
var {
    Input
} = require("react-bootstrap");
var CompanyStore = require("../../stores/CompanyStore");
var AuthActions     = require("../../actions/AuthenticationActions");
var _ = require("underscore");

var EditProfileForm = React.createClass({
    mixins: [LinkedStateMixin],
    getInitialState: function() {
        var departments = CompanyStore.getState().departments;

        return {
            id: this.props.department && this.props.department.id || "",
            name: this.props.department && this.props.department.name || "",
            departments: departments,

            id: this.props.user && this.props.user.id || "",
            username: this.props.user && this.props.user.username || "",
            first_name: this.props.user && this.props.user.first_name || "",
            last_name: this.props.user && this.props.user.last_name || "",
            email: this.props.user && this.props.user.email || "",
            password: "",
            passwordConfirm: "",
            "passwordValid": false,
            is_active: this.props.user && this.props.user.is_active || false,
            home_department: this.props.user && this.props.user.home_department || "",
            departments: departments
        };
    },
    onSubmit() {
        // Initialize user object.
        var newUser = {
            "username": this.state.username,
            "first_name": this.state.first_name,
            "last_name": this.state.last_name,
            "email": this.state.email,
            "is_active": this.state.is_active,
            "home_department": this.state.home_department
        };

        if (this.state.password !== "" && this.state.password === this.state.passwordConfirm) {
            newUser["password"] = this.state.password;
        }

        // Trigger an update request to the server.
        AuthActions.updateUserInfo({id: this.state.id, body: newUser});
    },
    mapDepartments: function(department, key) {
        if (!this.props.department) {
            return (<option key={key} value={department.id}>{department.name}</option>);
        } else if (department.id !== this.props.department.id) {
            return (<option key={key} value={department.id}>{department.name}</option>);
        } else {
            return null;
        }
    },
    render: function() {
        return (
            <div className="modal-body">
                <Input
                    label="Fornafn"
                    type="text"
                    placeholder="Sláðu inn fornafn"
                    valueLink={this.linkState("first_name")}
                />
                <Input
                    label="Eftirnafn"
                    type="text"
                    placeholder="Sláðu inn eftirnafn"
                    valueLink={this.linkState("last_name")}
                />
                <Input
                    label="Tölvupóstur"
                    type="text"
                    placeholder="Sláðu inn tölvupóst"
                    valueLink={this.linkState("email")}
                />
                <Input
                    label="Lykilorð"
                    type="password"
                    placeholder="Sláðu inn lykilorð"
                    valueLink={this.linkState("password")}
                />
                <Input
                    label="Staðfesta lykilorð"
                    type="password"
                    placeholder="Sláðu inn lykilorð"
                    valueLink={this.linkState("passwordConfirm")}
                />
                <Input
                    label="Virkur notandi"
                    type="checkbox"
                    checkedLink={this.linkState("is_active")}
                />
                <Input label="Heimadeild" type="select" valueLink={this.linkState("home_department")}>
                    <option key="default" value="">Veldu heimadeild</option>
                    {_.map(this.state.departments, this.mapDepartments)}
                </Input>
            </div>
        );
    }
});

module.exports = EditProfileForm;



// WEBPACK FOOTER //
// ./app/scripts/ui/UserProfile/EditProfileForm.js